"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckers = void 0;
const stype = require("./symTypes");
const errorMessages_1 = require("./errorMessages");
/* if all callees = caller, no terminate symbol -> no base case
 * if caller function always calls itself no matter what -> no base case
 */
function checkBaseCase(tset) {
    function getName(sym) {
        return sym.type === 'TerminateSymbol' ? '*' : sym.name;
    }
    const checkers = [];
    for (const [name, transitions] of tset.entries()) {
        const calleeNames = transitions.map(x => getName(x.callee));
        if (calleeNames.every(x => x === name)) {
            const loc = transitions[0].caller.loc;
            checkers.push(stype.makeLoopChecker(name, errorMessages_1.InfiniteLoopErrorMessage.no_base_case, null, loc));
        }
    }
    return checkers;
}
/* check if the function calls itself without swapping variables, i.e.
 * f(x,y) calls f(x+1,y+1) returns true, but
 * f(x,y) calls f(y,x) returns false
 */
function alignedArgs(f1, f2) {
    if (f1.args.length !== f2.args.length)
        return false;
    for (let i = 0; i < f1.args.length; i++) {
        const a1 = f1.args[i];
        const a2 = f2.args[i];
        const sameNumber = a1.type === 'NumberSymbol' && a2.type === 'NumberSymbol' && a1.name === a2.name;
        const hasSkip = a1.type === 'SkipSymbol' || a2.type === 'SkipSymbol';
        if (sameNumber || hasSkip) {
            continue;
        }
        return false;
    }
    return true;
}
function getArg(sym, name) {
    for (let i = 0; i < sym.args.length; i++) {
        const x = sym.args[i];
        if (x.type === 'NumberSymbol' && x.name === name) {
            return i;
        }
    }
    return -1;
}
function oneControlVar(transitions) {
    if (transitions.length === 0) {
        return true; // vacuously true?
    }
    const firstCond = transitions[0].condition;
    if ((firstCond === null || firstCond === void 0 ? void 0 : firstCond.type) === 'InequalitySymbol') {
        const name = firstCond.name;
        for (const transition of transitions) {
            const cond = transition.condition;
            if ((cond === null || cond === void 0 ? void 0 : cond.type) === 'InequalitySymbol' && cond.name === name) {
                continue;
            }
            return false;
        }
        return true;
    }
    return false;
}
/* checks for countdown functions, see documentation
 * for more details
 */
function checkCountdown(tset) {
    function check1(transition) {
        const caller = transition.caller;
        const callee = transition.callee;
        if (callee.type === 'FunctionSymbol' &&
            caller.name === callee.name &&
            alignedArgs(caller, callee)) {
            const cond = transition.condition;
            if ((cond === null || cond === void 0 ? void 0 : cond.type) === 'InequalitySymbol') {
                const idx = getArg(callee, cond.name);
                if (idx !== -1 && callee.args.length > idx) {
                    const arg = callee.args[idx];
                    if ((arg === null || arg === void 0 ? void 0 : arg.isPositive) && arg.constant * cond.direction > 0) {
                        return stype.makeLoopChecker(caller.name, errorMessages_1.InfiniteLoopErrorMessage.input_out_of_domain, cond, callee.loc);
                    }
                }
            }
        }
        return undefined;
    }
    const checkers = [];
    for (const transitions of tset.values()) {
        if (oneControlVar(transitions)) {
            for (const transition of transitions) {
                const checker = check1(transition);
                if (checker) {
                    checkers.push(checker);
                }
            }
        }
    }
    return checkers;
}
/* call all the variables that appear in the condition of the transition
 * 'relevant variables'. If the function calls itself but does not change
 * any of the relevant variables, there will be an infinite loop.
 */
function checkStateChange(tset) {
    function sameArgs(f1, f2, names) {
        if (f2.type !== 'FunctionSymbol' || f1.name !== f2.name || !alignedArgs(f1, f2))
            return false;
        for (let i = 0; i < f1.args.length; i++) {
            const a1 = f1.args[i];
            const a2 = f2.args[i];
            if (a1.type === 'NumberSymbol' &&
                a2.type === 'NumberSymbol' &&
                a1.name === a2.name &&
                a1.constant === a2.constant &&
                a1.isPositive === a2.isPositive) {
                // a1 & a2 are exactly the same
                continue;
            }
            for (const name of names) {
                if (a1.type === 'NumberSymbol' && a1.name === name)
                    return false;
            }
        }
        return true;
    }
    function getNames(sym) {
        if (sym === null)
            return [];
        if (sym.type === 'InequalitySymbol') {
            return [sym.name];
        }
        else {
            return getNames(sym.left).concat(getNames(sym.right));
        }
    }
    const checkers = [];
    for (const transitions of tset.values()) {
        for (const transition of transitions) {
            const cond = transition.condition;
            const caller = transition.caller;
            const callee = transition.callee;
            if (cond &&
                cond.type !== 'SkipSymbol' &&
                callee.type === 'FunctionSymbol' &&
                sameArgs(caller, callee, getNames(cond))) {
                const name = transition.caller.name;
                const checker = stype.makeLoopChecker(name, errorMessages_1.InfiniteLoopErrorMessage.no_state_change, cond, callee.loc);
                checkers.push(checker);
            }
        }
    }
    return checkers;
}
function getCheckers(tset) {
    const checkers1 = checkCountdown(tset);
    const checkers2 = checkBaseCase(tset);
    const checkers3 = checkStateChange(tset);
    return checkers1.concat(checkers2).concat(checkers3);
}
exports.getCheckers = getCheckers;
//# sourceMappingURL=analyzer.js.map